require('./bootstrap');

import { createApp } from "vue";

const vueApp = createApp({});

vueApp.component("start", require("./vue-components/start.vue").default);


vueApp.config.errorHandler = (err) => {
	console.error(err);
};

vueApp.mount("#vueApp");
